const BUCKET_NAME = 'labels';

export default class ThingLabelsController {
    /** @ngInject */
    constructor(EventEmitter) {
        this.eventEmitter = EventEmitter;
    }

    $onInit() {
        this.labels = [];
    }

    changed() {
        if (this.labels.length) {
            this.addItemToBucket(
                this.eventEmitter({
                    item: {
                        name: BUCKET_NAME,
                        value: this.labels
                    }
                })
            );
        } else {
            this.removeItemFromBucket(
                this.eventEmitter({
                    item: {
                        name: BUCKET_NAME
                    }
                })
            );
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-labels/thing-labels.controller.js